import { type NextProfitsTotalResponse, nextProfitsTotalResponseSchema } from 'investments/common/definitions'

import { httpClientBanking } from '~/domains/banking/shared/infra/http-client-banking'
import { type UseQueryRequestOptions, useQueryRequest } from '~/ui/hooks/utils/service/use-query-request'

async function fetchBucketNextProfitsTotal({ accountId, bucketId }: { accountId: string; bucketId: string }) {
  const { data } = await httpClientBanking({
    url: `/investments/accounts/${accountId}/buckets/${bucketId}/next_profits/total`,
    method: 'GET'
  })

  return nextProfitsTotalResponseSchema.parse(data)
}

export function getUseFetchBucketNextProfitsTotalKey(accountId: string, bucketId: string) {
  return ['useFetchBucketNextProfitsTotal', accountId, bucketId] as const
}

export function useFetchBucketNextProfitsTotal({
  accountId,
  bucketId,
  options
}: {
  accountId: string
  bucketId: string
  options?: UseQueryRequestOptions<NextProfitsTotalResponse, unknown, true>
}) {
  return useQueryRequest<NextProfitsTotalResponse, unknown, true>(
    getUseFetchBucketNextProfitsTotalKey(accountId, bucketId),
    () => fetchBucketNextProfitsTotal({ accountId, bucketId }),
    {
      suspense: false,
      retry: false,
      ...options
    }
  )
}
